export enum CountertopUniversityType {
    Course = 7017,
    Survey = 7018,
    Certification = 7019,
    Academy = 7020
}